var React = require('react');

function SliderLeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3217","data-name":"Path 3217","d":"M14.77,7l-7.2,7.2,7.2,7.2","transform":"translate(-4.388 -5.409)","fill":"none","stroke":"#fff","strokeWidth":"4.5"}));
}

SliderLeftArrow.defaultProps = {"width":"11.973","height":"17.582","viewBox":"0 0 11.973 17.582"};

module.exports = SliderLeftArrow;

SliderLeftArrow.default = SliderLeftArrow;
